import { useEffect, useState } from "react";
import { TaxableBase } from "../TaxableBase";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { TaxableBaseUBL } from "./TaxableBaseUBL";


interface Props {
    objetoTax: any;
    _onChange: any;
}
export const TaxBaseEditorUBL = ({ objetoTax, _onChange }: Props) => {

    const [invoice, setInvoice] = useState<any>({});
    const [bean, setBean] = useState<any>({});

    useEffect(() => {
        setBean({ ...objetoTax });
        let x = {};
        try {
            x = JSON.parse(localStorage.getItem("SimulatorInvoice")) || {}
        } catch (error) {
            console.error(error)
        }
        setInvoice(x);
    }, [objetoTax])

    let taps = [
        { id: 0, name: 'Seleccionar Base', disable: false },
        { id: 1, name: 'Escribir Base', disable: false },
    ];

    const [indexTap, setIndexTap] = useState(0);

    const updateClick = (value: any) => {
        _onChange({ TaxBase: value });
    }

    const updateRow = (values: any) => {
        let uBean = { OBIDDocument: values.OBIDDocument, TaxBase: values.TaxableAmount, BudgetID: values.BudgetID, IDBudgetResource: values.IDBudgetResource, IDBudgetSource: values.IDBudgetSource };
        _onChange(uBean);
    }

    useEffect(() => {
        _onChange({ TaxBase: bean.TaxBase })
    }, [bean.TaxBase])

    return (
        <div className="row">
            <div className="col-md-12">
                {invoice.IDUBLInvoice ?
                    <>
                        {invoice.PaymentType === 17 &&
                            <TaxableBaseUBL invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                        }
                        {invoice.PaymentType === 18 &&
                            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                                {indexTap === 0 &&
                                    <TaxableBaseUBL invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                                }
                                {indexTap === 1 &&
                                    <div className="row">
                                        <div className="col-12">
                                            <label >Base</label>
                                            <input type="text" className="form-control" value={bean.TaxableBase} onChange={(e) => { setBean({ ...bean, "TaxBase": parseInt(e.target.value) }) }} />
                                        </div>
                                        <div className="col-md-12 mt-4">
                                            <BasicButton icon="" eventClick={() => { _onChange(bean) }}>Guardar</BasicButton>
                                        </div>
                                    </div>
                                }
                            </CardTaps>
                        }
                        {!invoice.PaymentType &&
                            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                                {indexTap === 0 &&
                                    <TaxableBaseUBL invoice={invoice} _returnValue={(e) => { updateClick(e) }} _onChange={(e) => { updateRow(e) }} />
                                }
                                {indexTap === 1 &&
                                    <div className="row">
                                        <div className="col-12">
                                            <label >Base</label>
                                            <input type="text" className="form-control" value={bean.TaxableBase} onChange={(e) => { setBean({ ...bean, "TaxBase": parseInt(e.target.value) }) }} />
                                        </div>
                                    </div>
                                }
                            </CardTaps>
                        }
                    </>
                    :
                    <div className="row">
                        <div className="col-12">
                            <label >Base</label>
                        </div>
                        <div className="col-12">
                            <input type="text" className="form-control" value={bean.TaxBase} onChange={(e) => { setBean({ ...bean, "TaxBase": parseInt(e.target.value) }) }} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}